import React, {useEffect, useState} from 'react'
import Footer from '../Footer/Footer'
import Header from '../Header/Header'
import axios from "axios"
import style from "./News.module.css"

const News = () => {
 const [pizzas, setPizzas] = useState([]);
   useEffect(() => {
    axios
      .get("https://kudapizza.herokuapp.com/pizzas")
      .then((res) => {
        setPizzas(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);


  return (
    <>
      <Header />
      <div className={style.container}>
        <div className={style.news}>
          <h1 className={style.title}>PC BLOG</h1>
          <p className={style.description}>The Latest News, Offers, Announcements, and More From PC Engine! </p>
          <div className={style.cards}>
            {pizzas.map((el) => {
              return(
                
                <div key={el.id} className={style.main__pc}>
                  <img className={style.pc_image} src={el.image} alt="" />
                  <p>{el.name_ru}</p>
                  <h4 className={style.pc_title}>{el.name_en}</h4>
                  <p>{el.definition_en}</p>
                </div>
              )
            })}
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}

export default News